export default "__VITE_ASSET__QevseXUN__"